// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","453":"258b012d","732":"b498a8b3","977":"a5c2f382"}[chunkId] + ".chunk.js";
};